module.exports = __webpack_public_path__ + "img/bottom.70f00a24.png";